export function checkDocumentType(document: string): string {
	const valueLength = document.replace(/\.|-|\//g, '').length
	if (valueLength >= 12) {
		return 'CNPJ'
	} else {
		return 'CPF'
	}
}
